import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { Loading } from "@/components/States";
import HandoverView from "@/components/handover/HandoverView";

export default function HandoverPublic() {
  const { token } = useParams();
  const [pack, setPack] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    api.get(`/public/handover/${token}`).then((r) => setPack(r.data)).catch(() => setError("This handover package isn't available. The link may have been turned off."));
    // eslint-disable-next-line react-hooks/exhaustive-deps -- reload only when the token changes
  }, [token]);

  if (error) return <div className="grid min-h-screen place-items-center bg-stone-50 p-8 text-center text-stone-600" data-testid="handover-public-error">{error}</div>;
  if (!pack) return <div className="min-h-screen bg-stone-50 p-8"><Loading rows={4} /></div>;
  return <HandoverView pack={pack} />;
}
